export default "__VITE_ASSET__cIEqDi8A__"